import React, { useRef, useEffect, useState } from 'react';
import { Loading } from 'react-style-guide';
import PropTypes from 'prop-types';
import carouselService from '../../gameCarousel/services/carouselService';
import GameTile from '../../gameTile/containers/GameTile';
import FeatureGameTile from '../../gameTile/components/FeatureGameTile';

function GridContainer({
  eventRef,
  gamesData,
  sort,
  isNumberRowsLimited,
  pageType,
  featureUniverseId,
  isDataFetching,
  sortPosition,
  pageContext,
  ...props
}) {
  const gameTileRef = useRef();
  const { numberOfRows, name: sortName } = sort;
  const [style, setStyle] = useState({ height: 'auto' });
  useEffect(() => {
    if (isNumberRowsLimited && gameTileRef.current) {
      const heightOfTile = carouselService.getGameTileHeight(gameTileRef.current) + 12;
      setStyle({
        height: `${heightOfTile * numberOfRows}px`
      });
    }
  }, [gameTileRef, isNumberRowsLimited, numberOfRows]);

  return (
    <div
      data-testid='game-grid-grid-container'
      className='multi-row clearfix game-grid-container'
      style={style}>
      {gamesData &&
        gamesData.map((game, index) => {
          const keyValue = `${game.universeId}${index}`;
          if (game.universeId === featureUniverseId) {
            return (
              <li className='featured-game-tile' key={keyValue} title={game?.name}>
                <FeatureGameTile
                  game={game}
                  pageType={pageType}
                  index={index}
                  sortName={sortName}
                  sortPosition={sortPosition}
                  pageContext={pageContext}
                  {...props}
                  ref={gameTileRef}
                />
              </li>
            );
          }
          return (
            <li ref={eventRef} className='game-card game-tile' key={keyValue} title={game?.name}>
              <GameTile
                game={game}
                pageType={pageType}
                index={index}
                sortName={sortName}
                sortPosition={sortPosition}
                pageContext={pageContext}
                {...props}
                ref={gameTileRef}
              />
            </li>
          );
        })}
      {isDataFetching ? <Loading /> : null}
    </div>
  );
}

GridContainer.defaultProps = {
  eventRef: undefined,
  gamesData: [],
  isNumberRowsLimited: false,
  sort: { numberOfRows: 1 },
  featureUniverseId: 0,
  isDataFetching: false,
  sortPosition: -1,
  pageContext: {
    pageId: null
  }
};

GridContainer.propTypes = {
  eventRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) })
  ]),
  gamesData: PropTypes.arrayOf(PropTypes.shape({ universeId: PropTypes.number })),
  sort: PropTypes.shape({ numberOfRows: PropTypes.number, name: PropTypes.string }),
  isNumberRowsLimited: PropTypes.bool,
  pageType: PropTypes.string.isRequired,
  featureUniverseId: PropTypes.number,
  isDataFetching: PropTypes.bool,
  sortPosition: PropTypes.number,
  pageContext: PropTypes.shape({ pageId: PropTypes.string }),
  translate: PropTypes.func.isRequired
};

export default GridContainer;
